import {useSearchParams} from 'react-router-dom';

import {isShareView, SHARE_PANEL_PARAM} from '../utils';

import type {ShareView} from '../utils';

/** The share panel's open view lives in `?share=`, so a link can open it; `null` while it's closed. */
export function useSharePanelParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get(SHARE_PANEL_PARAM);

  const setPanelView = (view: ShareView | null) =>
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        if (view) next.set(SHARE_PANEL_PARAM, view);
        else next.delete(SHARE_PANEL_PARAM);
        return next;
      },
      {replace: true}
    );

  return {panelView: isShareView(param) ? param : null, setPanelView};
}
